'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalEventWrapper = function (_Component) {
  _inherits(GlobalEventWrapper, _Component);

  function GlobalEventWrapper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GlobalEventWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GlobalEventWrapper.__proto__ || Object.getPrototypeOf(GlobalEventWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.bindEvents = function () {
      (0, _lodash.keys)(_this.props.triggers).forEach(function (eventKey) {
        document.addEventListener(eventKey, _this.handleEvent);
      });
    }, _this.unbindEvents = function () {
      (0, _lodash.keys)(_this.props.triggers).forEach(function (eventKey) {
        document.removeEventListener(eventKey, _this.handleEvent);
      });
    }, _this.handleEvent = function (event) {
      var triggers = _this.props.triggers[event.type];
      triggers && triggers.forEach(_this.callTrigger.bind(_this, event));
    }, _this.setWrapperRef = function (node) {
      _this.wrapperRef = node;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GlobalEventWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.bindEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEvents();
    }
  }, {
    key: 'callTrigger',
    value: function callTrigger(event, trigger) {
      if (!trigger.conditional || trigger.conditional(event, this.wrapperRef)) {
        trigger.callback(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;

      return _react2.default.createElement(
        'div',
        { className: className, ref: this.setWrapperRef },
        this.props.children
      );
    }
  }]);

  return GlobalEventWrapper;
}(_react.Component);

/* The shape of triggers looks like this:
{
  keydown: [
    {
      callback: event => {},
      conditional: event => {},
    },
    ...
  ],
  click: [...];
}
*/


GlobalEventWrapper.propTypes = {
  className: _propTypes2.default.string,
  triggers: _propTypes2.default.object.isRequired
};

GlobalEventWrapper.defaultProp = {
  conditional: function conditional() {
    return true;
  }
};

exports.default = GlobalEventWrapper;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/GlobalEventWrapper.js
// module id = 145
// module chunks = 0